"use client";

import { phoneNumberSchema } from "src/validators";
import { z } from "zod";

export type CreateCustomerModalSchemaType = z.infer<
  typeof createCustomerModalSchema
>;

export const createCustomerModalSchema = z
  .object({
    name: z.string().min(1, { message: "Required" }),
    phoneNumber: phoneNumberSchema(true),
    country: z.string().min(1, { message: "Required" }),
    city: z.string().min(1, { message: "Required" }),
    address: z.string().optional(),
    isAssignSalesperson: z.boolean(),
    salespersonId: z
      .number({
        coerce: true,
        invalid_type_error: "Required",
      })
      .optional(),
    contractDatePeriod: z
      .object(
        {
          from: z.date().optional(),
          to: z.date().optional(),
        },
        {
          required_error: "Please select a date range",
        }
      )
      .nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.isAssignSalesperson && !data.salespersonId) {
      ctx.addIssue({
        path: ["salespersonId"],
        code: "custom",
        message: "Salesperson is required when assigning",
      });
    }
  });
